<template>
  <div
    class="border-solid cursor-pointer bg-gray-400 border-gray-200 border-1 inline-flex overflow-hidden"
    :class="[radiusClass]"
    @click="handleImageClick"
  >
    <img :src="proxiedUrl" class="h-full w-full" loading="lazy" alt="" />
  </div>
</template>

<script>
import { computed } from 'vue'
import { openPdfViewer } from '@/utils/events'

export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    w: {
      type: [String, Number],
      default: 100
    },
    h: {
      type: [String, Number],
      default: null
    },
    fit: {
      type: String,
      default: 'cover',
      validator: val => ['contain', 'cover'].includes(val)
    },
    radiusClass: {
      type: String,
      default: 'rounded-xl'
    },
  },
  setup (props) {
    const proxiedUrl = computed(() => {
      const url = new URL(props.url)
      const height = props.h ?? props.w

      url.searchParams.append('output', 'webp')
      url.searchParams.append('q', 90)
      url.searchParams.append('w', props.w)
      url.searchParams.append('h', height)
      url.searchParams.append('fit', props.fit)

      return url.toString()
    })

    function handleImageClick () {
      openPdfViewer(props.url)
    }

    return {
      proxiedUrl,
      handleImageClick
    }
  }
}
</script>
